export const waitForCondition = async (condition: () => boolean, timeout = 250) =>
  new Promise<void>((resolve) => {
    const interval = setInterval(() => {
      if (condition()) {
        resolve()
        clearInterval(interval)
      }
    }, timeout)
  })
